import { BreakpointObserver } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';

import get from 'lodash-es/get';
import isEmpty from 'lodash-es/isEmpty';
import { ExxComError } from 'lib/classes/exxcom-error.class';
import { BsModalService } from 'ngx-bootstrap/modal';

const scriptName = 'exxcom-component.class';

export class ExxComComponentClass {
    breakpointObserver: BreakpointObserver;
    environment: any;
    isBrowser: boolean;
    isNarrow: boolean = false;
    isTablet: boolean;
    modalService: BsModalService;
    constructor({ dependencies }: { dependencies?: any } = {}) {
        try {
            if (!isEmpty(dependencies)) {
                Object.keys(dependencies).forEach((k: string) => (this[k] = dependencies[k]));
            }
            if (get(dependencies, 'platformId')) {
                this.isBrowser = isPlatformBrowser(dependencies.platformId);
            }
            if (get(dependencies, 'breakpointObserver')) {
                this.initBreakpointListener();
            }
        } catch (err) {
            console.error(...new ExxComError(295772, scriptName, err).stamp());
        }
    }

    initBreakpointListener() {
        try {
            this.breakpointObserver
                .observe(['only screen and (min-width: 1100px)', 'only screen and (min-width: 576px)'])
                .subscribe((result: any) => {
                    // Defer to next tick to avoid NG0100 during initial render
                    setTimeout(() => {
                        this.isNarrow = !result.breakpoints['only screen and (min-width: 1100px)'];
                        this.isTablet = result.breakpoints['only screen and (min-width: 576px)'] && this.isNarrow;
                    }, 0);
                });
        } catch (err) {
            console.error(...new ExxComError(650050, scriptName, err).stamp());
        }
    }

    // HTML helpers

    isEmpty(ob: any) {
        return isEmpty(ob);
    }

    get(ob: any, args: any, defaultValue?: any) {
        return get(ob, args, defaultValue);
    }
}
